import React, {Component} from 'react';
import clone from 'clone';
import DatasetSortable from '../prototypes/DatasetSortable';
import moment from 'moment';
import DateTime from 'react-datetime';
import Loading from './Loading';

export default class ReactGrid extends Component {
  constructor( props ) {
    super( props );
    this.gridRef = React.createRef( );
    
    let isLoading = true;
    if( props.dataSource !== undefined ) {
      if( props.dataSource.length > 0 ) { 
        isLoading = false;
      }
    }

    this.state = {
      height: props.height === undefined ? 'auto' : props.height,
      width: props.width === undefined ? 'auto': props.width,
      dataSource: props.dataSource === undefined ? [] : props.dataSource,
      paging: props.paging === undefined ? false : props.paging,
      pageSize: props.pageSize === undefined ? 0 : props.pageSize,
      pageIndex: props.pageIndex === undefined ? 0 : props.pageIndex,
      noFooter: props.noFooter === undefined ? false : props.noFooter,
      loading: isLoading
    };

    // Bound Events
    this.onColumnClicked = this.onColumnClicked.bind( this );
    this.onCellChanged = this.onCellChanged.bind( this );
    this.onIconClicked = this.onIconClicked.bind( this );
    this.onFormatReadOnlyRow = this.onFormatReadOnlyRow.bind( this );
    this.onFormatReadOnlyCell = this.onFormatReadOnlyCell.bind( this );
    this.onFormatReadOnlyCellLabel = this.onFormatReadOnlyCellLabel.bind( this );

    // Bound Functions
    this.getChangedRowsCount = this.getChangedRowsCount.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.noFooter === true ){
      this.setState( {
        dataSource: nextProps.dataSource === undefined ? [] : nextProps.dataSource,
        paging: nextProps.paging === undefined ? false : nextProps.paging,
        pageSize: nextProps.pageSize === undefined ? 0 : nextProps.pageSize,
        pageIndex: nextProps.pageIndex === undefined ? 0 : nextProps.pageIndex,
        noFooter: nextProps.noFooter === undefined ? false : nextProps.noFooter,
        loading: false
      } );
    } else {
      this.setState( {
        height: nextProps.height === undefined ? 'auto' : nextProps.height,
        width: nextProps.width === undefined ? 'auto': nextProps.width,
        dataSource: nextProps.dataSource === undefined ? [] : nextProps.dataSource,
        paging: nextProps.paging === undefined ? false : nextProps.paging,
        pageSize: nextProps.pageSize === undefined ? 0 : nextProps.pageSize,
        pageIndex: nextProps.pageIndex === undefined ? 0 : nextProps.pageIndex,
        noFooter: nextProps.noFooter === undefined ? false : nextProps.noFooter,
        loading: false
      } );
    }
  }

  componentDidMount(){
  }

  getChangedRowsCount( ) {
    const dataSource = this.state.dataSource === undefined ? [] : this.state.dataSource;
    let changed = 0;
    if( dataSource.length > 0 ) {
      for( let index = 0; index < dataSource.length; index++ ) {
        const row = dataSource[ index ];
        if( row.changed === true ) {
          changed += 1;
        }
      }
    }
    return changed;
  }

  onColumnClicked( args ) {
    if( args.type === 'column' ) {
      // Create the new search option
      const newOptions = {
        key: args.column,
        direction: args.direction,
        datatype: args.datatype,
        precision: args.precision
      };

      // Get the data source
      let dataSource = this.state.dataSource;

      // External sorting
      let sortable = [];
      let newDataSource = [];

      if( this.props.onSortGrid !== undefined ){
        newDataSource = this.props.onSortGrid( dataSource, newOptions );
      } else {
        // Create sortable prototype object
        sortable = new DatasetSortable( dataSource, newOptions );
        // Sort the dataset;
        newDataSource = sortable.Sort();
      }

      if( this.props.onDataSourceChanged !== undefined ) {
        this.props.onDataSourceChanged( newDataSource );
      } else {
        // Update the state with new sorted data source 
        // if it is not passed to the parent
        this.setState( {
          dataSource: newDataSource,
        } );
      }
    } else if( args.type === 'icon' ) {
      const iconKey = args.key.toLowerCase();
      if( iconKey === 'save' ) {
        let changed = this.getChangedRowsCount();
        if( this.props.onIconColumnClicked !== undefined ) {
          args['changed'] = changed;
          this.props.onIconColumnClicked( args );
        }
      } else if( iconKey === 'delete' ) {
        if( this.props.onIconColumnClicked !== undefined ) {
          args['rows'] = this.state.dataSource;
          this.props.onIconColumnClicked( args );
        }
      }
    }
  } 

  onCellChanged( args ) {
    let rows = this.state.dataSource;
    if( rows !== undefined ) {
      if( rows.length > 0 ) {
        if( this.props.onCellChanged !== undefined ) {
          args['oldrow'] = rows[ args.rowIndex ];
          args['newrow'] = clone( rows[ args.rowIndex ] );
          args['newrow'][ args.column ] = args.newvalue;
          args['newrow'][ 'changed' ] = true;
          this.props.onCellChanged( args );
        }
      }
    }
  }

  onIconClicked( args ) {
    if( this.props.onIconClicked !== undefined ) {
      args[ 'row' ] = this.state.dataSource[ args.rowIndex ];
      this.props.onIconClicked( args );
    }
  }

  onFormatReadOnlyRow( args ) {
    if( this.props.onFormatReadOnlyRow !== undefined ) {
      return this.props.onFormatReadOnlyRow( args );
    }
  }

  onFormatReadOnlyCell( args ) {
    if( this.props.onFormatReadOnlyCell !== undefined ) {
      this.props.onFormatReadOnlyCell( args );
    }
  }

  onFormatReadOnlyCellLabel( args ) {
    if( this.props.onFormatReadOnlyCellLabel !== undefined ) {
      this.props.onFormatReadOnlyCellLabel( args );
    }
  }

  onRenderChildren( children ) {
    let renderedChildren = [];
    let hasHeader = false;
    let hasBody = false;
    const dataSource = this.state.dataSource;
    const paging = this.state.paging;
    const pageSize = this.state.pageSize;
    const pageIndex = this.state.pageIndex;
    
    if( React.Children.count( children ) <= 0 || children === '' ) {
      return renderedChildren;
    }

    React.Children.map( children, ( child ) => {

      const tagName = child.props.tagName === undefined ? '' : child.props.tagName;
      if( tagName === 'header' && hasHeader === false ) {
        hasHeader = true;
        let renderedReactGridHeader = (
          <ReactGridHeader 
            key="react-grid-header"
            onColumnClicked={this.onColumnClicked} 
            grid={this.gridRef}
            {...child.props}>
            {child.props.children}
          </ReactGridHeader>
        );
        renderedChildren.push( renderedReactGridHeader );
      }
      if( tagName === 'body' && hasBody === false ) {
        hasBody = true;
        let renderedReactGridBody = (
          <ReactGridBody 
            key='react-grid-body'
            dataSource={dataSource}
            paging={paging}
            pageSize={pageSize}
            pageIndex={pageIndex} 
            onCellChanged={this.onCellChanged}
            onIconClicked={this.onIconClicked}
            onFormatReadOnlyRow={this.onFormatReadOnlyRow}
            onFormatReadOnlyCell={this.onFormatReadOnlyCell}
            onFormatReadOnlyCellLabel={this.onFormatReadOnlyCellLabel}
            grid={this.gridRef.current}
            ReactGridBodyStyles={this.props.ReactGridBodyStyles}
            {...child.props}>
            {child.props.children}
          </ReactGridBody>
        );
        renderedChildren.push( renderedReactGridBody );
      }
      return child;
    } );
    return renderedChildren;
  }

  getGridStyles() { 
    let styles = {};

    if ( this.state.height !== 'auto' ) {
      const heightFloat = parseFloat( this.state.height.replace( 'vh' ) );
      styles.gridTemplateRows = '5vh ' + ( heightFloat - 5.0 ) + 'vh';
    }
    
    styles.width = this.state.width;
    styles.height = this.state.height;

    if( this.props.style !== undefined ){
      styles = Object.assign( styles, this.props.style );
    }

    return styles;
  }

  render( ) {
    if( this.state.loading === true ) { 
      return (
        <Loading caption="Loading Rows..." width="250px" />
      );
    } else {
      return (
        <span ref={this.gridRef} className="react-grid" style={this.getGridStyles()}>
          {this.onRenderChildren( this.props.children )}
        </span>
      );
    }
  }
}

export class ReactGridHeader extends Component {
  constructor( props ) {
    super( props );
    this._isMounted = false;
    this.headerRef = React.createRef( );
    this.onColumnClicked = this.onColumnClicked.bind( this );
  }

  componentDidMount( ) {
    this._isMounted = true;
  }

  componentWillUnmount( ) {
    this._isMounted= false;
  }

  getGridHeaderStyles( children ) {
    let styles = {};
    let columnWidths = [];

    if( React.Children.count( children ) <= 0 || children === '' ) {
      return styles;
    }

    React.Children.map( children, ( child ) => {
      const tagName = child.props.tagName === undefined ? '' : child.props.tagName;
      if( tagName === 'column' ) {
        if( child.props.width !== undefined ) {
          columnWidths.push( child.props.width );
        } else {
          columnWidths.push( 'auto' );
        }
      }
      return children;
    } );
    
    if( columnWidths !== undefined ) {
      if( columnWidths.length > 0 ) {
        styles['gridTemplateColumns'] = columnWidths.join( ' ' );
      }
    }
    return styles;
  }

  onColumnClicked( args ) {
    if( this.props.onColumnClicked !== undefined ) {
      this.props.onColumnClicked( args );
    }
  }

  onRenderChildren( children ) {
    let renderedChildren = [];
    
    if( React.Children.count( children ) <= 0 || children === '' ) {
      return renderedChildren;
    }

    React.Children.map( children, ( child, index ) => {
      const columnKey = 'react-grid-column-' + index.toString();
      const tagName = child.props.tagName === undefined ? '' : child.props.tagName;
      if( tagName === 'column' ) {
        let renderedReactGridColumn = (
          <ReactGridColumn 
            key={columnKey}
            columnKey={columnKey}
            index={index}
            onColumnClicked={this.onColumnClicked}
            grid={child.props.grid}
            header={this.headerRef}
            {...child.props}>
            {child.props.children}
          </ReactGridColumn>
        );
        renderedChildren.push( renderedReactGridColumn );
      }
      return children;
    } );
    return renderedChildren;
  }

  render() {
    return (
      <span ref={this.headerRef} className="react-grid-header" style={this.getGridHeaderStyles( this.props.children )}>
        {this.onRenderChildren( this.props.children )}
      </span>
    );
  }
}

export class ReactGridColumn extends Component {
  constructor( props ) {
    super( props );
    this._isMounted = false;
    this.columnRef = React.createRef();
    this.state = {
      caption: props.caption === undefined ? '' : props.caption,
      sorted: props.sorted === undefined ? '' : props.sorted,
      tooltip: props.tooltip === undefined ? '' : props.tooltip,
      index: props.index === undefined ? 0 : parseInt( props.index, 10 ),
      position: props.index === undefined ? 1 : parseInt( props.index, 10 ) + 1,
      width: props.width === undefined ? 'auto' : props.width,
      datatype: props.datatype === undefined ? 'string' : props.datatype,
      precision: props.precision === undefined ? 0 : parseInt( props.precision, 10 ),
      icon: props.icon === undefined ? '' : props.icon,
      grid: props.grid,
      sortDirection: ''
    };
    
    // Bound events
    this.onColumnClicked = this.onColumnClicked.bind( this );

  }
  
  componentDidMount() {
    this._isMounted = true;
  }

  componentWillReceiveProps( nextProps ) {
    if( this._isMounted === true ) {
      this.setState( {
        caption: nextProps.caption === undefined ? '' : nextProps.caption,
        sorted: nextProps.sorted === undefined ? '' : nextProps.sorted,
        tooltip: nextProps.tooltip === undefined ? '' : nextProps.tooltip,
        index: nextProps.index === undefined ? '' : parseInt( nextProps.index, 10 ),
        position: nextProps.index === undefined ? 1 : parseInt( nextProps.index, 10 ) + 1,
        width: nextProps.width === undefined ? 'auto' : nextProps.width,
        datatype: nextProps.datatype === undefined ? 'string' : nextProps.datatype,
        precision: nextProps.precision === undefined ? 0 : parseInt( nextProps.precision, 10 ),
        icon: nextProps.icon === undefined ? '' : nextProps.icon,
        grid: nextProps.grid
      } );
    }
  }
  
  componentWillUnmount( ) {
    this._isMounted = false;
  }

  onColumnClicked( e ) {
    let args = {};

    // If sort is not given then the onColumnClicked prop will not fire
    if( this.state.sorted !== '' ) {
      if( this.state.sorted === 'icon' ){
        args = {
          type: 'icon',
          key: this.state.caption
        };
        this.props.onColumnClicked( args );
      
      // None Icon sorts
      } else {
        const canSort = this.state.sorted === '' ? false : true;
        let sortDirection = this.getSortDirection( this.state.sortDirection );
        if( this.props.onColumnClicked !== undefined ) {
          args = {
            columnIndex: this.state.index,
            column: this.state.sorted,
            canSort: canSort,
            direction: sortDirection,
            datatype: this.state.datatype,
            precision: this.state.precision,
            type: 'column'
          };
          this.props.onColumnClicked( args );
        }

        this.setState( {
          sortDirection: sortDirection
        } );

      }
    }
  }
  
  getSortDirection( direction ) {

    if( direction === '' ) {
      return 'asc';
    }

    if( direction === undefined ) {
      return 'asc';
    }

    if( direction === null ) {
      return 'asc';
    }

    if( direction === 'asc' ) {
      return 'desc';
    }

    if( direction === 'desc' ) {
      return 'asc';
    }

  }


  getGridColumnStyle() {
    let styles = {};
    let columnStart = this.state.position === undefined ? 1 : parseInt( this.state.position, 10 );
    let columnEnd = columnStart + 1;
    styles['gridColumnStart'] = columnStart;
    styles['gridColumnEnd'] = columnEnd;
    styles['gridRowStart'] = 1;
    styles['gridRowEnd'] = 2;
    return styles;
  }

  getGridColumnTooltipStyle() {
    let styles = {};
    if( this.columnRef.current !== null ) {
      const top = ( this.columnRef.current.offsetTop - 85 ) + 'px';
      const left = this.columnRef.current.offsetLeft - 35 + 'px';
      styles['top'] = top;
      styles['left'] = left;
    }
    return styles;
  }

  render() {
    const columnIndex = this.state.index;
    const columnKey = this.props.columnKey === undefined ? 'react-grid-column-' + columnIndex.toString() : this.props.columnKey;
    
    // Column class rendering
    let columnClassName = this.state.sortDirection === '' ? 'react-grid-column' : this.state.sortDirection === 'asc' ? 'react-grid-column-asc' : 'react-grid-column-desc';
    if( this.state.sorted === undefined || this.state.sorted === '' ){
      columnClassName = 'react-grid-column-no-sort';
    }

    const icon = this.state.icon;

    if( ( icon === undefined ) || ( icon === null ) || ( icon === '' ) ) {
      return (
        <span 
          ref={this.columnRef}
          key={columnKey} 
          className={columnClassName}
          style={this.getGridColumnStyle()} 
          onClick={this.onColumnClicked}>
          {this.state.caption}
        </span>
      );
    } else {
      const iconClassName = 'react-grid-column-icon ' + this.state.icon;
      return (
        <span 
          ref={this.columnRef}
          key={columnKey} 
          className='react-grid-column'
          style={this.getGridColumnStyle()} 
          onClick={this.onColumnClicked}>
          <i className={iconClassName} onClick={this.onColumnClicked} />
          <span className='react-grid-column-tooltip' style={this.getGridColumnTooltipStyle()}>
            {this.state.tooltip}
          </span>
        </span>
      );
    }
  }
}

export class ReactGridBody extends Component {
  constructor( props ) {
    super( props );
    this._isMounted = false;
    this.bodyRef = React.createRef();
    this.state = {
      maxHeight: props.maxHeight === undefined ? 'auto' : props.maxHeight,
      dataSource: props.dataSource === undefined ? [] : props.dataSource,
      paging: props.paging === undefined ? false : props.paging,
      pageSize: props.pageSize === undefined ? 0 : props.pageSize,
      pageIndex: props.pageIndex === undefined ? 0 : props.pageIndex,
    };

    this.onCellChanged = this.onCellChanged.bind( this );
    this.onIconClicked = this.onIconClicked.bind( this );
    this.onFormatReadOnlyRow = this.onFormatReadOnlyRow.bind( this );
    this.onFormatReadOnlyCell = this.onFormatReadOnlyCell.bind( this );
    this.onFormatReadOnlyCellLabel = this.onFormatReadOnlyCellLabel.bind( this );
  }

  componentDidMount( ) {
    this._isMounted = true;
  }
  
  componentWillUnmount( ) {
    this._isMounted = false;
  }

  componentWillReceiveProps( nextProps ) {
    if( this._isMounted === true ) {
      this.setState( {
        maxHeight: nextProps.maxHeight === undefined ? 'auto' : nextProps.maxHeight,
        dataSource: nextProps.dataSource === undefined ? [] : nextProps.dataSource,
        paging: nextProps.paging === undefined ? false : nextProps.paging,
        pageSize: nextProps.pageSize === undefined ? 0 : nextProps.pageSize,
        pageIndex: nextProps.pageIndex === undefined ? 0 : nextProps.pageIndex,
      } );
    }
  }

  getReactGridBodyStyles( ) {
    let styles = {};
    const rows = this.state.dataSource.length;
    const maxHeight = ( rows * 100 ) + 'px';
    if( rows > 0 ) {
      styles['height']= 'auto';
      styles['maxHeight'] = maxHeight;
    } else {
      styles['height']= 'auto';
      styles['maxHeight'] = 'auto';
    }

    if( this.props.ReactGridBodyStyles !== undefined ){
      styles = Object.assign( styles, this.props.ReactGridBodyStyles );
    }

    return styles;
  }

  onCellChanged( args ) {
    if( this.props.onCellChanged !== undefined ) {
      this.props.onCellChanged( args );
    }
  }

  onIconClicked( args ) {
    if( this.props.onIconClicked !== undefined ) {
      this.props.onIconClicked( args );
    }
  }

  onFormatReadOnlyRow( args ){
    if( this.props.onFormatReadOnlyRow !== undefined ) {
      return this.props.onFormatReadOnlyRow( args );
    }
  }

  onFormatReadOnlyCell( args ) {
    if( this.props.onFormatReadOnlyCell !== undefined ) {
      this.props.onFormatReadOnlyCell( args );
    }
  }

  onFormatReadOnlyCellLabel( args ) {
    if( this.props.onFormatReadOnlyCellLabel !== undefined ) {
      this.props.onFormatReadOnlyCellLabel( args );
    }
  }

  onRenderChildren( children ) {
    let renderedChildren = [];
    let dataSource = this.state.dataSource;

    if( React.Children.count( children ) <= 0 || children === '' ) {
      return renderedChildren;
    }
    React.Children.map( children, ( child ) => { 
      const tagName = child.props.tagName === undefined ? '' : child.props.tagName;

      if( tagName === 'noRowTemplate' ) {
        if( dataSource !== undefined ) {
          if( dataSource.length === 0 ) {
            const rowKey = 'react-grid-no-rows';
            const renderedReactGridNoRowsTemplate = (
              <ReactGridNoRowsTemplate 
                key={rowKey}
                {...child.props}>
                {child.props.children}
              </ReactGridNoRowsTemplate>
            );
            renderedChildren.push( renderedReactGridNoRowsTemplate );
          }
        }
      }

      if( tagName === 'rowTemplate' ) {
        if( dataSource !== undefined ) {
          if( dataSource.length > 0 ) {
            const paging = this.state.paging;
            const pageSize = parseInt( this.state.pageSize, 10 );
            const pageIndex = parseInt( this.state.pageIndex, 10 );
            let pageStart = 0;
            if( paging === true ) {
              pageStart = pageSize * pageIndex;
            }

            for( let rowIndex = 0; rowIndex < pageSize; rowIndex++ ) {
              let assignedRowIndex = rowIndex + pageStart;
              const rowKey = 'react-grid-row-' + assignedRowIndex.toString();
              const row = dataSource[ rowIndex + pageStart ];
              if( row === undefined ) {
                break;
              }

              const renderedReactGridRowTemplate = (
                <ReactGridRowTemplate
                  key={rowKey}
                  rowIndex={rowIndex} 
                  assignedRowIndex={assignedRowIndex}
                  row={row}
                  onCellChanged={this.onCellChanged}
                  onIconClicked={this.onIconClicked}
                  onFormatReadOnlyRow={this.onFormatReadOnlyRow}
                  onFormatReadOnlyCell={this.onFormatReadOnlyCell}
                  onFormatReadOnlyCellLabel={this.onFormatReadOnlyCellLabel}
                  grid={child.props.grid}
                  {...child.props} >
                  {child.props.children}                        
                </ReactGridRowTemplate>
              );
              renderedChildren.push( renderedReactGridRowTemplate );
            }
          }
        }
      }

      return child;
    } );
    return renderedChildren;
  }

  render() {
    return (
      <span ref={this.bodyRef} className="react-grid-body" style={this.getReactGridBodyStyles()}>
        {this.onRenderChildren( this.props.children )}
      </span>
    );
  }
}

export class ReactGridRowTemplate extends Component {
  constructor( props ) {
    super( props );
    this._isMounted = false;
    this.state = {
      height: props.height === undefined ? 'auto' : props.height,
      rowIndex: props.rowIndex === undefined ? 0 : props.rowIndex,
      assignedRowIndex: props.assignedRowIndex === undefined ? 0 : props.assignedRowIndex,
      row: props.row === undefined ? {} : props.row,
      grid: props.grid
    };
    
    // Component Events
    this.onCellChanged = this.onCellChanged.bind( this );
    this.onIconClicked = this.onIconClicked.bind( this );
    this.onFormatReadOnlyRow = this.onFormatReadOnlyRow.bind( this );
    this.onFormatReadOnlyCell = this.onFormatReadOnlyCell.bind( this );
    this.onFormatReadOnlyCellLabel = this.onFormatReadOnlyCellLabel.bind( this );
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount( ) {
    this._isMounted = false;
  }

  componentWillReceiveProps( nextProps ) {
    if( this._isMounted === true ) {
      this.setState( {
        height: nextProps.height === undefined ? 'auto' : nextProps.height,
        rowIndex: nextProps.rowIndex === undefined ? 0 : nextProps.rowIndex,
        assignedRowIndex: nextProps.assignedRowIndex === undefined ? 0 : nextProps.assignedRowIndex,
        row: nextProps.row === undefined ? {} : nextProps.row,
        grid: nextProps.grid
      } );
    }
  }

  onCellChanged( args ) {
    if( this.props.onCellChanged !== undefined ) {
      this.props.onCellChanged( args );
    }
  }

  onIconClicked( args ) {
    if( this.props.onIconClicked !== undefined ) {
      this.props.onIconClicked( args );
    }
  }

  onFormatReadOnlyRow( args ) {
    if( this.props.onFormatReadOnlyRow !== undefined ) {
      return this.props.onFormatReadOnlyRow( args );
    }
  }

  onFormatReadOnlyCell( args ) {
    if( this.props.onFormatReadOnlyCell !== undefined ) {
      this.props.onFormatReadOnlyCell( args );
    }
  }

  onFormatReadOnlyCellLabel( args ) {
    if( this.props.onFormatReadOnlyCellLabel !== undefined ) {
      this.props.onFormatReadOnlyCellLabel( args );
    }
  }

  getReactGridRowTemplateStyles( children ) {
    let styles = {};

    if( React.Children.count( children ) <= 0 || children === '' ) {
      return styles;
    }

    const rowIndex = parseInt( this.state.rowIndex, 10 );
    styles['height'] = this.state.height;
    styles['gridColumnStart'] = 1;
    styles['gridColumnEnd'] = 2;
    styles['gridRowStart'] = rowIndex + 1;
    styles['gridRowEnd'] = rowIndex + 2;
    let columnWidths = [];

    React.Children.map( children, ( child ) => {
      const tagName = child.props.tagName === undefined ? '' : child.props.tagName;
      if( tagName === 'readOnlyCell' || 
          tagName === 'iconCell' || 
          tagName === 'dropDownCell' ||
          tagName === 'textAreaCell' ||
          tagName === 'textboxCell' ||
          tagName === 'dateTimeCell' ) {
        if( child.props.width !== undefined ) {
          columnWidths.push( child.props.width );
        } else {
          columnWidths.push( 'auto' );
        }
      } 
      return children;
    } );

    if( columnWidths !== undefined ) {
      if( columnWidths.length > 0 ) {
        styles['gridTemplateColumns'] = columnWidths.join( ' ' );
      }
    }
    return styles;
  }

  onRenderChildren( children ) {
    let renderedChildren = [];
    const row = this.state.row;
    const rowIndex = this.state.rowIndex;
    const assignedRowIndex = this.state.assignedRowIndex;
    let cellIndex = 0;

    if( React.Children.count( children ) <= 0 || children === '' ) {
      return renderedChildren;
    }

    React.Children.map( children, ( child, index ) => {
      const cellKey = 'react-grid-cell-' + rowIndex.toString() + '-' + cellIndex.toString();
      const tagName = child.props.tagName === undefined ? '' : child.props.tagName;
      if( tagName === 'readOnlyCell' ) {
        const value = row[ child.props.column ];
        const renderedReactGridReadOnlyCell = (
          <ReactGridReadOnlyCell 
            key={cellKey}
            rowIndex={rowIndex}
            cellIndex={cellIndex}
            value={value}
            grid={child.props.grid}
            onFormatReadOnlyCell={this.onFormatReadOnlyCell}
            onFormatReadOnlyCellLabel={this.onFormatReadOnlyCellLabel} 
            {...child.props}>
            {child.props.children}
          </ReactGridReadOnlyCell>
        );
        renderedChildren.push( renderedReactGridReadOnlyCell );
        cellIndex += 1;
      } else if( tagName === 'iconCell' ) {
        const iconColor= row.changed === undefined ? 'black' : row.changed === true ? '#00796C' : 'black';
        const renderedReactGridIconCell = (
          <ReactGridIconCell 
            key={cellKey}
            rowIndex={rowIndex}
            cellIndex={index}
            assignedRowIndex={assignedRowIndex}
            grid={child.props.grid}
            iconColor={iconColor}
            onIconClicked={this.onIconClicked} 
            {...child.props}>
            {child.props.children}
          </ReactGridIconCell>
        );
        renderedChildren.push( renderedReactGridIconCell );
        cellIndex += 1;
      } else if( tagName === 'dropDownCell' ) {
        const value = row[ child.props.column ];
        const renderedReactGridDropDownCell = (
          <ReactGridDropDownCell 
            key={cellKey}
            rowIndex={rowIndex}
            cellIndex={index}
            value={value}
            grid={child.props.grid}
            onCellChanged={this.onCellChanged} 
            {...child.props}>
            {child.props.children}
          </ReactGridDropDownCell>
        );
        renderedChildren.push( renderedReactGridDropDownCell );
        cellIndex += 1;
      } else if( tagName === 'textAreaCell' ) {
        const value = row[ child.props.column ];
        const renderedReactGridTextAreaCell = (
          <ReactGridTextAreaCell 
            key={cellKey}
            rowIndex={rowIndex}
            cellIndex={index}
            value={value}
            grid={child.props.grid}
            onCellChanged={this.onCellChanged} 
            {...child.props}>
            {child.props.children}                  
          </ReactGridTextAreaCell>
        );
        renderedChildren.push( renderedReactGridTextAreaCell );
        cellIndex += 1;
      } else if ( tagName === 'textboxCell' ) {
        const value = row[ child.props.column ];
        const renderedReactGridTextboxCell = (
          <ReactGridTextboxCell
            key={cellKey}
            rowIndex={rowIndex}
            cellIndex={index}
            value={value}
            grid={child.props.grid}
            onCellChanged={this.onCellChanged} 
            {...child.props}>
            {child.props.children}
          </ReactGridTextboxCell>
        );
        renderedChildren.push( renderedReactGridTextboxCell );
        cellIndex += 1;
      } else if ( tagName === 'dateTimeCell' ) {
        const value = row[ child.props.column ];
        const renderedReactGridDateTimeCell = (
          <ReactGridDateTimeCell
            key={cellKey}
            rowIndex={rowIndex}
            cellIndex={index}
            value={value}
            grid={child.props.grid}
            onCellChanged={this.onCellChanged} 
            {...child.props}>
            {child.props.children}
          </ReactGridDateTimeCell>
        );
        renderedChildren.push( renderedReactGridDateTimeCell );
        cellIndex += 1;
      }
      return child;
    } );
    return renderedChildren;
  }

  render() {
    let rowClassName='react-grid-alt-row-template ';
    const rowIndex = parseInt( this.state.rowIndex, 10 );
    if( rowIndex % 2 === 0 || rowIndex === 0 ) {
      rowClassName='react-grid-row-template ';
    }

    // Initial styles
    let styles = this.getReactGridRowTemplateStyles( this.props.children );
    let additionalClassName = '';
    const additionalStyles = this.onFormatReadOnlyRow( this.props );

    // Adding new styles
    if( additionalStyles !== undefined ){

      // Modifying the styles of the row React Object
      Object.assign( styles, additionalStyles.style );

      // Assigning a className if it exist
      if( additionalStyles['className'] !== undefined ){

        // Clearing the row styles
        if( additionalStyles.overwriteClassName === true ){
          rowClassName = '';
        }

        additionalClassName = additionalStyles['className'];
      }
    }

    return (
      <span className={rowClassName + additionalClassName} style={styles} >
        {this.onRenderChildren( this.props.children )}
      </span>
    );
  }
}

export class ReactGridNoRowsTemplate extends Component {
  constructor( props ) {
    super( props );
    this.gridNoRowsTemplateRef = React.createRef();
    this.state = {
      height: props.height === undefined ? 'auto' : props.height
    };
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        height: nextProps.height === undefined ? 'auto' : nextProps.height
      } );
    }
  }

  compareProps( props, nextProps ) {
    if( props.height !== nextProps.height ) {
      return true;
    }
    return false;
  }

  getReactGridNoRowsTemplateStyles() {
    let styles = {};
    styles['height'] = this.state.height;
    return styles;
  }

  render() {
    return (
      <span ref={this.gridNoRowsTemplateRef} className="react-grid-no-rows-template" style={this.getReactGridNoRowsTemplateStyles()}>
        {this.props.children}
      </span>
    );
  }
}

export class ReactGridReadOnlyCell extends Component {
  constructor( props ) {
    super( props );
    this.readOnlyCellRef = React.createRef();
    this.state = {
      cellIndex: props.cellIndex === undefined ? 0 : props.cellIndex,
      rowIndex: props.rowIndex === undefined ? 0 : props.rowIndex,
      width: props.width === undefined ? 'auto' : props.width,
      column: props.column === undefined ? '' : props.column,
      value: props.value === undefined ? '' : props.value,
      align: props.align === undefined ? 'center' : props.align,
      bold: props.bold === undefined ? false : props.bold,
      format: props.format === undefined ? '' : props.format,
      precision: props.precision === undefined ? 0 : props.precision,
      sorted: ''
    };

    // Bound Events
    this.onFormatReadOnlyCell = this.onFormatReadOnlyCell.bind( this );
    this.onFormatReadOnlyCellLabel = this.onFormatReadOnlyCellLabel.bind( this );
    this.getValueStyles = this.getValueStyles.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        cellIndex: nextProps.cellIndex === undefined ? 0 : nextProps.cellIndex,
        rowIndex: nextProps.rowIndex === undefined ? 0 : nextProps.rowIndex,
        width: nextProps.width === undefined ? 'auto' : nextProps.width,
        column: nextProps.column === undefined ? '' : nextProps.column,
        value: nextProps.value === undefined ? '' : nextProps.value,
        align: nextProps.align === undefined ? 'center' : nextProps.align,
        bold: nextProps.bold === undefined ? false : nextProps.bold,
        format: nextProps.format === undefined ? '' : nextProps.format,
        precision: nextProps.precision === undefined ? 0 : nextProps.precision
      } );
    }
  }

  compareProps( props, nextProps ) {
    
    if( props.cellIndex !== nextProps.cellIndex ) {
      return true;
    }

    if( props.rowIndex !== nextProps.rowIndex ) {
      return true;
    }

    if( props.width !== nextProps.width ) {
      return true;
    }

    if( props.column !== nextProps.column ) {
      return true;
    }

    if( props.value !== nextProps.value ) {
      return true;  
    }

    if( props.align !== nextProps.align ) {
      return true;
    }
    
    if( props.bold !== nextProps.bold ) {
      return true;
    }

    if( props.format !== nextProps.format ) {
      return true;
    }

    if( props.precision !== nextProps.precision ) {
      return true;
    }

    return false;
  }

  onFormatReadOnlyCell( styles ) {
    if( this.props.onFormatReadOnlyCell !== undefined ) {
      let args = {
        value: this.state.value,
        column: this.state.column,
        cellIndex: this.state.cellIndex,
        rowIndex: this.state.rowIndex,
        styles: styles
      };
      this.props.onFormatReadOnlyCell( args );
    }
  }

  onFormatReadOnlyCellLabel( styles ) {
    if( this.props.onFormatReadOnlyCellLabel !== undefined ) {
      let args = {
        value: this.state.value,
        column: this.state.column,
        cellIndex: this.state.cellIndex,
        rowIndex: this.state.rowIndex,
        styles: styles
      };
      this.props.onFormatReadOnlyCellLabel( args );
    }
  }

  getReactGridReadOnlyCellStyles( ) {
    let styles = {};
    const cellIndex = this.state.cellIndex;
    
    this.onFormatReadOnlyCell( styles );

    if( this.state.bold === true ) {
      styles['fontWeight'] = 'bold';
    }

    styles['width'] = this.state.width;
    const align = this.state.align.toLowerCase();

    if( align === 'left' ) {
      styles['justifyContent'] = 'flex-start';
    } else if( align === 'center' ) {
      styles['justifyContent'] = 'center';
    } else if( align === 'right' ) {
      styles['justifyContent'] = 'flex-end';
    } else {
      styles['justifyContent'] = 'center';
    }
    styles['padding'] = '5px';
    styles['gridColumnStart'] = cellIndex + 1;
    styles['gridColumnEnd'] = cellIndex + 2;
    styles['gridRowStart'] = 1;
    styles['gridRowEnd'] = 2;

    return styles;
  }

  getReactGridReadOnlyCellLabelStyles() {
    let styles = {};
    
    this.onFormatReadOnlyCellLabel( styles );

    return styles;
  }

  // Returns layout defined row styles, these are determined by value vs position (content vs position)
  getValueStyles(){
    const valueStyles = this.props.valueStyles;
    if( valueStyles !== undefined ){
      if( Object.keys( valueStyles ).length !== 0 && valueStyles.constructor === Object ){
        const value = String( this.props.value );
        const style = valueStyles[value];

        if( style !== undefined ){
          return style;
        }
      }
    }

    // Empty return on field not included in the layout
    return '';
  }

  getFormat( value, format ) {
    if( format === 'phone' ) {
      return this.getPhoneFormat( value );
    } else if( format === 'integer' ) {
      return this.getInteger( value );
    } else if( format === 'float' ) {
      const precision = this.state.precision === undefined ? 0 : this.state.precision;
      return this.getFloat( value, precision );
    } else if( format === 'currency' ) {
      return this.getCurrency( value );
    } else if( format === 'YYYY-MM-DD' ) {
      return this.getDateYYYYMMDD( value );
    } else if( format === 'MM-DD-YYYY' ) {
      return this.getDateMMDDYYYY( value );
    } else if( format === 'HH:mm:ss' ) {
      return this.getTimeHHmmss( value );
    } else if( format === 'datetime' ) {
      return this.getDateTime( value );
    }
    return value;
  }

  getPhoneFormat( value ) {
    let newValue = '';
    if( value.length === 11 ) {
      newValue = value.substring( 0, 1 ) + '.' + value.substring( 1, 4 ) + '.' + value.substring( 4, 7 ) + '.' + value.substring( 7, 12 );
    } else if( value.length === 10 ) {
      newValue = value.substring( 0, 3 ) + '.' + value.substring( 3, 7 ) + '.' + value.substring( 7, 11 ); 
    } else {
      return value;
    }
    return newValue;
  }

  getInteger( value ) {
    return parseInt( value, 10 );
  }

  getFloat( value, precision ) {
    return parseFloat( value ).toFixed( precision );
  }

  getCurrency( value ) {
    if( value === undefined || value === '' ){
      return '';
    }
    return '$' + parseFloat( value ).toFixed( 2 ).toString();
  }

  getDateMMDDYYYY( value ) {
    return moment( value, "MM-DD-YYYY").format("MM-DD-YYYY").toString();
  }
  
  getDateYYYYMMDD( value ) {
    let newValue = '';

    if( value === undefined ) {
      return '';
    }
    
    if( value === null ) {
      return '';
    }

    if( value === '' ) {
      return '';
    }

    let dateString = value.toString();
    newValue = dateString.substring( 0, 4 ) + '-' + dateString.substring( 4, 6 ) + '-' + dateString.substring( 6, 8 );
    return newValue;
  }

  getTimeHHmmss( value ) {
    return moment(value, 'HH:mm:ss').format('HH:mm:ss').toString();
  }

  getDateTime( value ) {
    let dateTime = moment( value );
    return dateTime.format( 'YYYY-MM-DD HH:mm:ss' );
  }

  render( ) {
    const format = this.state.format;
    let value = this.state.value;
    
    if( format !== '' ) {
      value = this.getFormat( value, format );
    }

    let valueStylesString = this.getValueStyles();

    return (
      <span ref={this.readOnlyCellRef} className={'react-grid-readonly-cell ' + valueStylesString} style={this.getReactGridReadOnlyCellStyles()}>
        <span className="react-grid-readonly-cell-label" style={this.getReactGridReadOnlyCellLabelStyles()}>
          {value}
        </span>
      </span>
    );
  }
}

export class ReactGridIconCell extends Component {
  constructor( props ) {
    super( props );
    this._isMounted = false;
    this.cellRef = React.createRef( );
    this.state = {
      cellIndex: props.cellIndex === undefined ? 0 : props.cellIndex,
      rowIndex: props.rowIndex === undefined ? 0 : props.rowIndex,
      assignedRowIndex: props.assignedRowIndex === undefined ? 0 : props.assignedRowIndex,
      width: props.width === undefined ? 'auto' : props.width,
      icon: props.icon === undefined ? '' : props.icon,
      iconKey: props.iconKey === undefined ? '' : props.iconKey,
      iconColor: props.iconColor === undefined ? 'black' : props.iconColor
    };

    // Bound Events
    this.onClick = this.onClick.bind( this );
  }

  componentDidMount( ) {
    this._isMounted = true;
    this.setState( {
      isMounted: true      
    } );
  }

  componentWillUnmount( ) {
    this._isMounted=false;
  }

  componentWillReceiveProps( nextProps ) {
    if( this._isMounted === true ) {
      this.setState( {
        cellIndex: nextProps.cellIndex === undefined ? 0 : nextProps.cellIndex,
        rowIndex: nextProps.rowIndex === undefined ? 0 : nextProps.rowIndex,
        assignedRowIndex: nextProps.assignedRowIndex === undefined ? 0 : nextProps.assignedRowIndex,
        width: nextProps.width === undefined ? 'auto' : nextProps.width,
        icon: nextProps.icon === undefined ? '' : nextProps.icon,
        iconKey: nextProps.iconKey === undefined ? '' : nextProps.iconKey,
        iconColor: nextProps.iconColor === undefined ? 'black' : nextProps.iconColor,
        tooltip: nextProps.tooltip === undefined ? 'black' : nextProps.tooltip
      } );
    }
  }

  onClick( e ) {
    if( this.props.onIconClicked !== undefined ) {
      let args = {
        cellIndex: this.state.cellIndex,
        rowIndex: this.state.assignedRowIndex,
        iconKey: this.state.iconKey
      };
      this.props.onIconClicked( args );
    }
  }

  getReactGridIconCellStyles( ) {
    let styles = {};
    const cellIndex = this.state.cellIndex;

    styles['width'] = this.state.width;
    styles['color'] = this.state.iconColor;
    styles['gridColumnStart'] = cellIndex + 1;
    styles['gridColumnEnd'] = cellIndex + 2;
    styles['gridRowStart'] = 1;
    styles['gridRowEnd'] = 2;

    return styles;
  }

  render( ) {
    return (
      <span ref={this.cellRef} className="react-grid-icon-cell" style={this.getReactGridIconCellStyles()}>
        <i className={this.state.icon} onClick={this.onClick} />
      </span>
    );
  }
}

export class ReactGridDropDownCell extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      cellIndex: props.cellIndex === undefined ? 0 : props.cellIndex,
      rowIndex: props.rowIndex === undefined ? 0 : props.rowIndex,
      width: props.width === undefined ? 'auto' : props.width,
      column: props.column === undefined ? '' : props.column,
      value: props.value === undefined ? '' : props.value,
      options: props.options === undefined ? [] : props.options,
      align: props.align === undefined ? 'center' : props.align
    };

    this.onChange = this.onChange.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      cellIndex: nextProps.cellIndex === undefined ? 0 : nextProps.cellIndex,
      rowIndex: nextProps.rowIndex === undefined ? 0 : nextProps.rowIndex,
      width: nextProps.width === undefined ? 'auto' : nextProps.width,
      column: nextProps.column === undefined ? '' : nextProps.column,
      value: nextProps.value === undefined ? '' : nextProps.value,
      options: nextProps.options === undefined ? [] : nextProps.options,
      align: nextProps.align === undefined ? 'center' : nextProps.align
    } );
  }

  onChange( e ) {
    if( this.props.onCellChanged !== undefined ) {
      const oldvalue = parseInt( this.state.value, 10 );
      const newvalue = parseInt( e.target.value, 10 );
      let args = {
        column: this.state.column,
        rowIndex: this.state.rowIndex,
        cellIndex: this.state.cellIndex,
        oldvalue: parseInt( this.state.value, 10 ),
        newvalue: parseInt( e.target.value, 10 ),
        changed: oldvalue !== newvalue ? true : false
      };
      this.props.onCellChanged( args );
    }
  }

  getReactGridStaticDropDownCellStyles( ) {
    let styles = {};
    const cellIndex = this.state.cellIndex;
    styles['width'] = this.state.width;
    const align = this.state.align.toLowerCase();
    if( align === 'left' ) {
      styles['justifyContent'] = 'flex-start';
      styles['paddingLeft'] = '5px';
    } else if( align === 'center' ) {
      styles['justifyContent'] = 'center';
    } else if( align === 'right' ) {
      styles['justifyContent'] = 'flex-end';
      styles['paddingRight'] = '5px';
    } else {
      styles['justifyContent'] = 'center';
    }

    styles['gridColumnStart'] = cellIndex + 1;
    styles['gridColumnEnd'] = cellIndex + 2;

    styles['gridRowStart'] = 1;
    styles['gridRowEnd'] = 2;

    return styles;
  }

  onRenderOptions() {
    let renderedOptions = [];
    const options = this.state.options;
    renderedOptions = options.map( ( option, index ) => {
      const optionKey = 'react-grid-dropdown-cell-option-' + index.toString();
      return (
        <option key={optionKey} value={option.id} onChange={this.onChange}>
          {option.text}
        </option>
      );
    } );
    return renderedOptions;
  }

  render( ) {
    return (
      <span className="react-grid-dropdown-cell" style={this.getReactGridStaticDropDownCellStyles()}>
        <select 
          className="react-grid-dropdown-control edit-section-dropdown" 
          value={this.state.value} 
          onChange={this.onChange}>
          {this.onRenderOptions()}
        </select>
      </span>
    );
  }
}

export class ReactGridTextAreaCell extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      cellIndex: props.cellIndex === undefined ? 0 : props.cellIndex,
      rowIndex: props.rowIndex === undefined ? 0 : props.rowIndex,
      width: props.width === undefined ? 'auto' : props.width,
      column: props.column === undefined ? '' : props.column,
      value: props.value === undefined ? '' : props.value,
      align: props.align === undefined ? 'center' : props.align,
      bold: props.bold === undefined ? false : props.bold
    };

    this.onChange = this.onChange.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        cellIndex: nextProps.cellIndex === undefined ? 0 : nextProps.cellIndex,
        rowIndex: nextProps.rowIndex === undefined ? 0 : nextProps.rowIndex,
        width: nextProps.width === undefined ? 'auto' : nextProps.width,
        column: nextProps.column === undefined ? '' : nextProps.column,
        value: nextProps.value === undefined ? '' : nextProps.value,
        align: nextProps.align === undefined ? 'center' : nextProps.align,
        bold: nextProps.bold === undefined ? false : nextProps.bold
      } );
    }
  }

  compareProps( props, nextProps ) {
    
    if( props.cellIndex !== nextProps.cellIndex ) {
      return true;
    }

    if( props.rowIndex !== nextProps.rowIndex ) {
      return true;
    }

    if( props.width !== nextProps.width ) {
      return true;
    }

    if( props.column !== nextProps.column ) {
      return true;
    }

    if( props.value !== nextProps.value ) {
      return true;  
    }

    if( props.align !== nextProps.align ) {
      return true;
    }
    
    if( props.bold !== nextProps.bold ) {
      return true;
    }

    return false;
  }

  onChange( e ) {
    if( this.props.onCellChanged !== undefined ) {
      let args = {
        column: this.state.column,
        rowIndex: this.state.rowIndex,
        cellIndex: this.state.cellIndex,
        oldvalue: this.state.value,
        newvalue: e.target.value
      };
      this.props.onCellChanged( args );
    }
  }
 
  getReactGridTextAreaCellStyles( ) {
    let styles = {};
    const cellIndex = this.state.cellIndex;
    
    if( this.state.bold === true ) {
      styles['fontWeight'] = 'bold';
    }

    styles['width'] = this.state.width;
    const align = this.state.align.toLowerCase();
    if( align === 'left' ) {
      styles['justifyContent'] = 'flex-start';
      styles['paddingLeft'] = '5px';
    } else if( align === 'center' ) {
      styles['justifyContent'] = 'center';
    } else if( align === 'right' ) {
      styles['justifyContent'] = 'flex-end';
      styles['paddingRight'] = '5px';
    } else {
      styles['justifyContent'] = 'center';
    }

    styles['gridColumnStart'] = cellIndex + 1;
    styles['gridColumnEnd'] = cellIndex + 2;

    styles['gridRowStart'] = 1;
    styles['gridRowEnd'] = 2;
 
    return styles;
  }

  render( ) {
    return (
      <span className="react-grid-textarea-cell" style={this.getReactGridTextAreaCellStyles()}>
        <textarea className="react-grid-textarea-control edit-section-textarea" onChange={this.onChange} value={this.state.value} />
      </span>
    );
  }
}

export class ReactGridTextboxCell extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      cellIndex: props.cellIndex === undefined ? 0 : props.cellIndex,
      rowIndex: props.rowIndex === undefined ? 0 : props.rowIndex,
      width: props.width === undefined ? 'auto' : props.width,
      column: props.column === undefined ? '' : props.column,
      value: props.value === undefined ? '' : props.value,
      align: props.align === undefined ? 'center' : props.align,
      bold: props.bold === undefined ? false : props.bold
    };

    this.onChange = this.onChange.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        cellIndex: nextProps.cellIndex === undefined ? 0 : nextProps.cellIndex,
        rowIndex: nextProps.rowIndex === undefined ? 0 : nextProps.rowIndex,
        width: nextProps.width === undefined ? 'auto' : nextProps.width,
        column: nextProps.column === undefined ? '' : nextProps.column,
        value: nextProps.value === undefined ? '' : nextProps.value,
        align: nextProps.align === undefined ? 'center' : nextProps.align,
        bold: nextProps.bold === undefined ? false : nextProps.bold
      } );
    }
  }

  compareProps( props, nextProps ) {
    
    if( props.cellIndex !== nextProps.cellIndex ) {
      return true;
    }

    if( props.rowIndex !== nextProps.rowIndex ) {
      return true;
    }

    if( props.width !== nextProps.width ) {
      return true;
    }

    if( props.column !== nextProps.column ) {
      return true;
    }

    if( props.value !== nextProps.value ) {
      return true;  
    }

    if( props.align !== nextProps.align ) {
      return true;
    }
    
    if( props.bold !== nextProps.bold ) {
      return true;
    }

    return false;
  }

  onChange( e ) {
    if( this.props.onCellChanged !== undefined ) {
      let args = {
        column: this.state.column,
        rowIndex: this.state.rowIndex,
        cellIndex: this.state.cellIndex,
        oldvalue: this.state.value,
        newvalue: e.target.value
      };
      this.props.onCellChanged( args );
    }
  }
 
  getReactGridTextboxCellStyles( ) {
    let styles = {};
    const cellIndex = this.state.cellIndex;
    
    if( this.state.bold === true ) {
      styles['fontWeight'] = 'bold';
    }

    styles['width'] = this.state.width;
    const align = this.state.align.toLowerCase();
    if( align === 'left' ) {
      styles['justifyContent'] = 'flex-start';
      styles['paddingLeft'] = '5px';
    } else if( align === 'center' ) {
      styles['justifyContent'] = 'center';
    } else if( align === 'right' ) {
      styles['justifyContent'] = 'flex-end';
      styles['paddingRight'] = '5px';
    } else {
      styles['justifyContent'] = 'center';
    }

    styles['gridColumnStart'] = cellIndex + 1;
    styles['gridColumnEnd'] = cellIndex + 2;

    styles['gridRowStart'] = 1;
    styles['gridRowEnd'] = 2;
 
    return styles;
  }

  render( ) {
    return (
      <span className="react-grid-textbox-cell" style={this.getReactGridTextboxCellStyles()}>
        <input className="react-grid-textbox-control edit-section-input" onChange={this.onChange} value={this.state.value} />
      </span>
    );
  }
}

export class ReactGridDateTimeCell extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      cellIndex: props.cellIndex === undefined ? 0 : props.cellIndex,
      rowIndex: props.rowIndex === undefined ? 0 : props.rowIndex,
      width: props.width === undefined ? 'auto' : props.width,
      column: props.column === undefined ? '' : props.column,
      value: props.value === undefined ? '' : props.value,
      align: props.align === undefined ? 'center' : props.align,
      bold: props.bold === undefined ? false : props.bold
    };

    this.onChange = this.onChange.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( {
        cellIndex: nextProps.cellIndex === undefined ? 0 : nextProps.cellIndex,
        rowIndex: nextProps.rowIndex === undefined ? 0 : nextProps.rowIndex,
        width: nextProps.width === undefined ? 'auto' : nextProps.width,
        column: nextProps.column === undefined ? '' : nextProps.column,
        value: nextProps.value === undefined ? '' : nextProps.value,
        align: nextProps.align === undefined ? 'center' : nextProps.align,
        bold: nextProps.bold === undefined ? false : nextProps.bold
      } );
    }
  }

  compareProps( props, nextProps ) {
    
    if( props.cellIndex !== nextProps.cellIndex ) {
      return true;
    }

    if( props.rowIndex !== nextProps.rowIndex ) {
      return true;
    }

    if( props.width !== nextProps.width ) {
      return true;
    }

    if( props.column !== nextProps.column ) {
      return true;
    }

    if( props.value !== nextProps.value ) {
      return true;  
    }

    if( props.align !== nextProps.align ) {
      return true;
    }
    
    if( props.bold !== nextProps.bold ) {
      return true;
    }

    return false;
  }

  onChange( e ) {
    if( this.props.onCellChanged !== undefined ) {
      let args = {
        column: this.state.column,
        rowIndex: this.state.rowIndex,
        cellIndex: this.state.cellIndex,
        oldvalue: this.state.value,
        newvalue: e._d
      };
      this.props.onCellChanged( args );
    }
  }
 
  getReactGridDateTimeCellStyles( ) {
    let styles = {};
    const cellIndex = this.state.cellIndex;
    
    if( this.state.bold === true ) {
      styles['fontWeight'] = 'bold';
    }

    styles['width'] = this.state.width;
    const align = this.state.align.toLowerCase();
    if( align === 'left' ) {
      styles['justifyContent'] = 'flex-start';
      styles['paddingLeft'] = '5px';
    } else if( align === 'center' ) {
      styles['justifyContent'] = 'center';
    } else if( align === 'right' ) {
      styles['justifyContent'] = 'flex-end';
      styles['paddingRight'] = '5px';
    } else {
      styles['justifyContent'] = 'center';
    }

    styles['gridColumnStart'] = cellIndex + 1;
    styles['gridColumnEnd'] = cellIndex + 2;

    styles['gridRowStart'] = 1;
    styles['gridRowEnd'] = 2;
 
    return styles;
  }

  render( ) {
    return (
      <span className="react-grid-datetime-cell" style={this.getReactGridDateTimeCellStyles()}>
        <DateTime
          className='react-grid-datetime-control'
          inputProps={{className: 'react-grid-datetime-input-control edit-section-input'}}
          value={this.state.value}
          onChange={this.onChange}
        />
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/presentation/ReactGrid.js